import { IPublicClientApplication } from '@azure/msal-browser';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import {
  addCountryProgramEligibilityRules,
  getCountryAwardNominationRole,
  getCountryProgramEligibilityRules,
} from './index';

export const createStaffProgramsApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  addCountryProgramEligibilityRules: (instance: IPublicClientApplication, programId: number, countryId: number, eligibilityRuleCodes: string[]) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => addCountryProgramEligibilityRules(fetchContext, programId, countryId, eligibilityRuleCodes, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('addCountryProgramEligibilityRules', isInFlight);
    },
  ),
  getCountryProgramEligibilityRules: (instance: IPublicClientApplication, programId: number, countryId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getCountryProgramEligibilityRules(fetchContext, programId, countryId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getCountryProgramEligibilityRules', isInFlight);
    },
  ),
  getCountryAwardNominationRole: (instance: IPublicClientApplication, programId: number, countryId: number, nominationId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getCountryAwardNominationRole(fetchContext, programId, countryId, nominationId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getCountryAwardNominationRole', isInFlight);
    },
  ),
});
